import React from 'react';
import { StyledButton } from './styles/Button.styles';

const ButtonControl = ({ control, renderMode }) => {
  return (
    <StyledButton styleProps={control.attributes} renderMode={renderMode}>
      {control.text}
    </StyledButton>
  );
};

export default ButtonControl;